import { memo, type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => {

  const {width = 16, height = 16} = props;

  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.316 14.667a6.666 6.666 0 1 1 0-13.333 6.666 6.666 0 0 1 0 13.333Zm0-1.334a5.333 5.333 0 1 0 0-10.666 5.333 5.333 0 0 0 0 10.666Zm-.667-8a.667.667 0 1 1 1.334 0 .667.667 0 0 1-1.334 0ZM7.65 8a.667.667 0 0 1 1.334 0v2.667a.667.667 0 1 1-1.334 0V8Z"
    />
  </svg>
  );
};
const Memo = memo(SvgComponent);
export { Memo as InfoIcon };
